import React, { Component } from "react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import newMarker from "../../img/svg/baseline-gps_fixed-24px.svg";
import L from "leaflet";
import PropTypes from "prop-types";

const geolocIcon = L.icon({
  iconUrl: newMarker,
  iconSize: [30, 30], // size of the icon
  iconAnchor: [20, 40], // point of the icon which will correspond to marker's location
  shadowAnchor: [4, 62], // the same for the shadow
  popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
});

class Maps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasLocation: false,
      lat: props.lat,
      lng: props.long,
      moveMarker: props.moveMarker || false,
      zoom: 18,
      draggable: true
    };
    this.refmarker = React.createRef();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.moveMarker !== prevState.moveMarker) {
      return {
        moveMarker: false
      };
    }
    if (nextProps.lat !== prevState.lat && !prevState.moveMarker) {
      return {
        lat: nextProps.lat,
        lng: nextProps.long
      };
    }
    return null;
  }

  toggleDraggable = () => {
    this.setState({ draggable: !this.state.draggable });
  };

  updatePosition = () => {
    const { lat, lng } = this.refmarker.current.leafletElement.getLatLng();
    this.setState(
      {
        lat: lat,
        lng: lng,
        moveMarker: true
      },
      () => {
        this.props.handleCoordinates(this.state.lat, this.state.lng);
      }
    );
  };

  render() {
    const position = [this.state.lat, this.state.lng];
    return (
      <Map center={position} zoom={this.state.zoom}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Marker
          draggable={this.state.draggable}
          onDragend={this.updatePosition}
          position={position}
          ref={this.refmarker}
          icon={geolocIcon}
        >
          <Popup minWidth={90}>
            <span onClick={this.toggleDraggable}>
              {this.state.draggable ? "DRAG MARKER" : "MARKER FIXED"}
            </span>
          </Popup>
        </Marker>
      </Map>
    );
  }
  static defaultProps = {
    moveMarker: false
  };
}

Maps.proptype = {
  lat: PropTypes.number,
  lng: PropTypes.number,
  moveMarker: PropTypes.bool.isRequired,
  handleCoordinates: PropTypes.func.isRequired
};

export default Maps;
